import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import sv from './public/locales/sv/index';
import en from "./public/locales/en/index"
import da from "./public/locales/da/index"
import no from "./public/locales/no/index"



i18n
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: en },
        sv: { translation: sv },
        no: { translation: no },
        da: { translation: da }
      },
      fallbackLng: 'en',
      ns: ['translation'],
      defaultNS: 'translation',
      keySeparator: ":",
      interpolation: {
        escapeValue: false,
        formatSeparator: ',',
      },
      react: {
        useSuspense: false
      },
    });
    
export default i18n;
